<template>
    <div class="main">
<!--        <my-nav-bar title="" :bordered="false" background="transparent" textColor="#FFF" :show-indicators="false">-->
<!--        </my-nav-bar>-->
        <i class="iconfont icon-xitongfanhui back-icon" @click="backPage"></i>
        <van-swipe class="my-swipe" :loop="false" :vertical="true" :initial-swipe="current" :show-indicators="false" @change="slide" v-if="videos.length > 0">
            <van-swipe-item v-for="item in videos" :key="item.id" @click="toggleVideo(item)">
                <video :src="item.video.video" class="video" loop :ref="`video-${item.video.id}`" />
                <i class="iconfont icon-play" v-if="!item.play"></i>
                <div class="operate-bar">
                    <div class="item" @click.stop="openDownModal">
                        <i class="iconfont icon-thumb"></i>
                        <span>{{item.video.loves || 0}}</span>
                    </div>
                    <div class="item">
                        <i class="iconfont icon-message"></i>
                        <span>{{ item.video.comments || 0 }}</span>
                    </div>
                    <div class="item" @click.stop="openDownModal">
                        <i class="iconfont icon-share1"></i>
                    </div>
                </div>
                <div class="title">{{item.video.title}}</div>
            </van-swipe-item>
        </van-swipe>
    </div>
</template>
<script>
import {videoDetailApi, prevVideoDetailApi, nextVideoDetailApi} from "@/request/api"
import {Toast} from "vant";
export default {
    data(){
        return{
            current: 0,
            detail: {},
            videos: [],
            // 没有上一个
            prevNull: false,
            // 没有下一个
            nextNull: false
        }
    },
    created() {
        let cid = this.$route.query.cid
        let id = this.$route.query.id
        this.getData(cid, id)
    },
    watch:{
        current(val){
            console.log(val);
        }
    },
    methods: {
        slide(index){
            this.detail = this.videos[index]
            // 播放视频
            this.toggleVideo(this.detail, true)
            // 当划到最后一个的时候拉去下一个
            if(index === this.videos.length - 1){
                this.$nextTick(()=>{
                    this.current = index;
                })
                this.nextData()
            }else if(index === 0){
                this.$nextTick(()=>{
                    this.current = index;
                })
                this.prevData()
            }
        },
        toggleVideo(item, replay = false){
            item.play = !item.play
            // 开始播放
            if(item.play){
                // 去掉其他视频的播放
                this.videos.forEach(item=>{
                    // 获取元素句柄暂停播放,需要异步
                    this.$nextTick(()=>{
                        let el = this.$refs[`video-${item.video.id}`][0]
                        el.pause()
                        item.play = false
                    })
                })
                // 获取当前句柄进行播放
                this.$nextTick(()=>{
                    let el = this.$refs[`video-${item.video.id}`][0]
                    if(replay){
                        // 重置播放进度
                        el.currentTime = 0
                    }
                    el.play()
                    item.play = true
                })
            }else{
                // 暂停当前的播放
                let el = this.$refs[`video-${item.video.id}`][0]
                el.pause()
            }
        },
        getData(cid, id){
            // 需要同时获取到上下条所有的数据
            Promise.all([prevVideoDetailApi({cid, id}), videoDetailApi({cid, id}), nextVideoDetailApi({cid, id})]).then(res=>{
                res.forEach((item, index)=>{
                    if(item.data){
                        this.videos.push({
                            ...item.data,
                            play: false
                        })
                    }else {
                        if(item.video.id){
                            this.videos.push({
                                ...item,
                                play: false
                            })
                        }else{
                            if(index == 0){
                                this.prevNull = true
                            }else if(index == 2){
                                this.nextNull = true
                            }
                        }
                    }
                })
                // 当上一条数据存在的时候，移动索引
                if(res[0].video.id){
                    this.current ++
                }
                // 保存当前的播放视频信息
                this.detail = res[1].data
            })
        },
        nextData(){
            if(this.nextNull)return Toast("没有更多了")
            let tmp = this.detail.video
            nextVideoDetailApi({cid: tmp.contentid, id: tmp.id}).then(res=>{
                console.log(res);
                this.videos.push({
                    ...res,
                    play: false
                })
            })
        },
        prevData(){
            if(this.prevNull)return Toast("没有更多了")
        },
        backPage(){
            this.$router.go(-1)
        },
    }
}
</script>
<style scoped lang="less">
.main{
    width: 100%;
    height: 100vh;
    background-color: #000;
    .my-swipe{
        width: 100%;
        height: 100%;
        color: #FFF;
        position: relative;
        .video{
            width: 100%;
            height: 100%;
        }
        .title{
            position: absolute;
            bottom: 130px;
            left: 0;
            color: #FFF;
            padding: 0 10px;
        }
        .icon-play{
            position: absolute;
            left: 50%;
            top: 50%;
            z-index: 1000;
            font-size: 50px;
            transform: translate(-50%, -50%);
        }
        .operate-bar{
            position: absolute;
            right: 20px;
            top: 55%;
            transform: translateY(-50%);
            .item{
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                margin-bottom: 30px;
                .iconfont{
                    font-size: 32px;
                }
            }
        }
    }
    .back-icon{
        position: fixed;
        left: 10px;
        top: 10px;
        color: #FFF;
        z-index: 10000;
    }
}
</style>
